import { AuthGuard } from "app/auth/helpers";
import { ChatComponent } from "./pages/chat/chat.component";

const chatRoutes: any[] = [
  {
    path: "dashboard/chat",
    canActivate: [AuthGuard],
    component: ChatComponent,
    data: { animation: "chat" },
  },
];

export default chatRoutes;
